"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var AccountAddresses = /** @class */ (function (_super) {
    __extends(AccountAddresses, _super);
    function AccountAddresses(props) {
        var _this = _super.call(this, props) || this;
        _this.form = _this.props.data.form.customer_address;
        _this.defaultAddress = {
            first_name: "",
            last_name: "",
            email: "",
            address1: "",
            address2: "",
            city: "",
            country: "Australia",
            country_code: "AU",
            province: "Victoria",
            province_code: "VIC",
            zip: "",
            phone: "",
            default: false,
            form: _this.form
        };
        _this.openForm = function (address) {
            _this.setState({
                selectedAddress: address,
                stateList: _this.state.countryList[address.country ? address.country : "Australia"].provinces
            }, function () {
                _this.props.toggleAddressForm();
            });
        };
        _this.closeForm = function (event, force) {
            if (force === void 0) { force = false; }
            if (event.target === event.currentTarget || force) {
                _this.setState({
                    selectedAddress: _this.defaultAddress,
                    stateList: null
                }, function () {
                    _this.props.toggleAddressForm();
                });
            }
        };
        _this.buildForm = function () {
            return _this.props.isAddressFormActive ? (React.createElement(Snippets.AddressForm, __assign({}, _this.props, { address: _this.state.selectedAddress, closeForm: _this.closeForm }))) : null;
        };
        _this.state = {
            // @ts-ignore
            countryList: window.Countries,
            stateList: null,
            addressList: _this.props.data.customer.addresses,
            selectedAddress: _this.defaultAddress
        };
        return _this;
    }
    AccountAddresses.prototype.render = function () {
        var _this = this;
        var defaultAddress = this.state.addressList.find(function (address) { return address.default == true; });
        var addresses = __spreadArrays([defaultAddress], this.state.addressList.filter(function (address) { return address.default == false; }));
        return (React.createElement("div", { className: "flex flex-wrap justify-between" },
            addresses.length > 0 && addresses[0] ? (addresses.map(function (address, index) { return (React.createElement(Snippets.Card, { className: "w-full md:w-49% pt-3-6 pb-3-1 pl-3-2 rounded", key: address.id },
                React.createElement("div", { className: "md:flex flex-col h-full flex-wrap " },
                    React.createElement("span", { className: "text-base font-semibold text-navy-dark mb-0-8 leading-normal tracking-wide uppercase inline-block" }, address.default ? "Primary Address" : "Address " + (index + 1)),
                    React.createElement(Snippets.AddressCard, { address: address, customer: _this.props.data.customer, deleteForm: _this.props.data.form.address_delete })))); })) : (React.createElement(Snippets.Card, { className: "w-full pt-3-6 pb-3-1 pl-3-2 rounded" },
                React.createElement("div", { className: "text-base font-bold text-navy-dark" }, "No Address, Add One?"))),
            React.createElement("section", { className: "fixed flex md:items-center justify-center pin z-100 overflow-auto p-1-6 " + (this.props.isAddressFormActive ? "transition visible" : "transition-fast invisible") },
                React.createElement("div", { className: "absolute pin bg-navy-dark " + (this.props.isAddressFormActive ? "transition opacity-60" : "transition-fast opacity-0"), onClick: function () { return _this.props.toggleAddressForm(); } }),
                React.createElement("div", { className: "relative w-full max-w-43-6 " + (this.props.isAddressFormActive
                        ? "transition transition-delay translate-y:0 visible opacity-100"
                        : "transition-fast transition-delay-none translate-y:20x invisible opacity-0") }, this.buildForm()))));
    };
    return AccountAddresses;
}(React.Component));
exports.AccountAddresses = AccountAddresses;
